import { useMemo, type JSX } from "react";

import { sanitizeEmailHtml } from "@/lib/sanitize";

export interface MessageHtmlProps {
  /** Untrusted email HTML, or null when only a text body exists. */
  readonly html: string | null;
}

/**
 * Renders sanitized email HTML. Sanitization runs in `useMemo` because it is
 * O(size of HTML) and must not repeat on unrelated re-renders. The value passed
 * to `dangerouslySetInnerHTML` is always the sanitized string.
 */
export function MessageHtml({ html }: MessageHtmlProps): JSX.Element {
  const clean = useMemo(() => (html === null ? "" : sanitizeEmailHtml(html)), [html]);

  if (html === null) {
    return <p className="text-muted-foreground text-sm">This message has no HTML body.</p>;
  }

  return <div className="email-body" dangerouslySetInnerHTML={{ __html: clean }} />;
}
